import { sheets } from '@/app/grid/controller/Sheets';
import { pixiApp } from '@/app/gridGL/pixiApp/PixiApp';
import type { Rectangle } from 'pixi.js';

/**
 * The viewport's visible world bounds, extended to include the frozen
 * (pinned) rows/columns region. Frozen panes always show the world from the
 * origin up to the freeze boundary regardless of scroll, so world-space UI
 * that culls or clips against the visible bounds (e.g. cell highlights) must
 * use these bounds — otherwise content in the frozen region is culled away
 * once the body scrolls past the freeze line.
 */
export function getVisibleBoundsIncludingFrozen(): Rectangle {
  const bounds = pixiApp.viewport.getVisibleBounds();
  const sheet = sheets.sheet;
  if (!sheet) return bounds;

  if (sheet.frozenColumns > 0 && bounds.x > 0) {
    bounds.width += bounds.x;
    bounds.x = 0;
  }
  if (sheet.frozenRows > 0 && bounds.y > 0) {
    bounds.height += bounds.y;
    bounds.y = 0;
  }
  return bounds;
}
